module.exports = __webpack_public_path__ + "static/media/avatar-3.41a180f3.jpg";